import { render, staticRenderFns } from "./IconStar.vue?vue&type=template&id=4aba8c95&scoped=true"
import script from "./IconStar.vue?vue&type=script&lang=js"
export * from "./IconStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba8c95",
  null
  
)

export default component.exports